// src/pages/Settings.js
import React from "react";
import { SlidersHorizontal, BellRing, Palette } from "lucide-react"; // Icons

export default function Settings() {
    return (
        <div className="min-h-screen bg-darkBg text-white p-6">
            <header className="mb-10 text-center">
                <h1 className="text-4xl font-extrabold text-green-400 custom-glow-text">
                    ⚙️ Settings
                </h1>
                <p className="text-gray-400 mt-2">Configure your PiWatch experience.</p>
            </header>

             <div className="glass-card glow-border p-8 max-w-2xl mx-auto rounded-xl text-center">
                 <SlidersHorizontal className="text-neonPink mx-auto mb-4" size={48} />
                 <h2 className="text-2xl font-semibold mb-4">Coming Soon!</h2>
                 <p className="text-gray-300 mb-2">
                     Configure application settings and preferences here.
                 </p>
                 <ul className="list-disc list-inside text-gray-400 text-left inline-block mb-6">
                    <li>Manage notification preferences <BellRing size={16} className="inline ml-1" />.</li>
                    <li>Customize dashboard appearance <Palette size={16} className="inline ml-1" /> (e.g., themes).</li>
                    <li>Set data retention policies.</li>
                    <li>Manage API keys or device credentials (future).</li>
                 </ul>
                  <p className="text-sm text-gray-500">Check back later for configuration options.</p>
             </div>
        </div>
    );
}